// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer rdg.MeasuringCell {.m1l09lto7-0-0-beta-36 {
    contain: strict;
    grid-row: 1;
    visibility: hidden
}
  }


@layer rdg.Cell {.c1wupbe7-0-0-beta-36 {
    /* max-content does not work with size containment
     * dynamically switching between different containment styles incurs a heavy relayout penalty
     * Chromium bug: at odd zoom levels or subpixel positioning, layout/paint containment can make cell borders disappear
     *   https://bugs.chromium.org/p/chromium/issues/detail?id=1326946
     */
    contain: style;
    position: relative; /* needed for absolute positioning to work */
    padding-block: 0;
    padding-inline: 8px;
    border-inline-end: 1px solid var(--rdg-border-color);
    border-block-end: 1px solid var(--rdg-border-color);
    grid-row-start: var(--rdg-grid-row-start);
    background-color: inherit;

    white-space: nowrap;
    overflow: hidden;
    overflow: clip;
    text-overflow: ellipsis;
    outline: none
}

    .c1wupbe7-0-0-beta-36[aria-selected='true'] {
      outline: 2px solid var(--rdg-selection-color);
      outline-offset: -2px;
    }
  }

@layer rdg.Cell {

.cd0kgiy7-0-0-beta-36 {
    position: sticky;
    /* Should have a higher value than 0 to show up above unfrozen cells */
    z-index: 1
}
  }

@layer rdg.Cell {

.c1730fa47-0-0-beta-36 {
    box-shadow: calc(2px * var(--rdg-sign)) 0 5px -2px rgba(136, 136, 136, 0.3)
}
  }


@layer rdg.CheckboxLabel {.c1hs68w07-0-0-beta-36 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
    margin-inline-end: 1px /* align checkbox in row group cell */
}
  }

@layer rdg.CheckboxInput {

.cojpd0n7-0-0-beta-36 {
    all: unset
}
  }

@layer rdg.CheckboxIcon {

.cwsfieb7-0-0-beta-36 {
    content: '';
    inline-size: 20px;
    block-size: 20px;
    border: 2px solid var(--rdg-border-color);
    background-color: var(--rdg-background-color)
}

    .cojpd0n7-0-0-beta-36:checked + .cwsfieb7-0-0-beta-36 {
      background-color: var(--rdg-checkbox-color);
      outline: 4px solid var(--rdg-background-color);
      outline-offset: -6px;
    }

    .cojpd0n7-0-0-beta-36:focus + .cwsfieb7-0-0-beta-36 {
      border-color: var(--rdg-checkbox-focus-color);
    }
  }

@layer rdg.CheckboxLabel {

.c1fgadbl7-0-0-beta-36 {
    cursor: default
}

    .c1fgadbl7-0-0-beta-36 .cwsfieb7-0-0-beta-36 {
      border-color: var(--rdg-checkbox-disabled-border-color);
      background-color: var(--rdg-checkbox-disabled-background-color);
    }
  }


@layer rdg.GroupCellContent {.g1w3c5217-0-0-beta-36 {
    outline: none
}
  }

@layer rdg.GroupCellCaret {

.cm5tyhw7-0-0-beta-36 {
    margin-inline-start: 4px;
    stroke: currentColor;
    stroke-width: 1.5px;
    fill: transparent;
    vertical-align: middle
}

    .cm5tyhw7-0-0-beta-36 > path {
      transition: d 0.1s;
    }
  }


@layer rdg.DragHandle {.cadd3bp7-0-0-beta-36 {
    cursor: move;
    position: absolute;
    inset-inline-end: 0;
    inset-block-end: 0;
    inline-size: 8px;
    block-size: 8px;
    background-color: var(--rdg-selection-color)
}

    .cadd3bp7-0-0-beta-36:hover {
      inline-size: 16px;
      block-size: 16px;
      border: 2px solid var(--rdg-selection-color);
      background-color: var(--rdg-background-color);
    }
  }


@layer rdg.EditCell {.c1tngyp17-0-0-beta-36 {
    padding: 0
}
  }


@layer rdg.SortableHeaderCell {.hizp7y17-0-0-beta-36 {
    cursor: pointer;
    display: flex
}

    .hizp7y17-0-0-beta-36:focus {
      outline: none;
    }
  }

@layer rdg.SortableHeaderCellName {

.h14cojrm7-0-0-beta-36 {
    flex-grow: 1;
    overflow: hidden;
    overflow: clip;
    text-overflow: ellipsis
}
  }


@layer rdg.HeaderCell {.celq7o97-0-0-beta-36 {
    touch-action: none
}

    .celq7o97-0-0-beta-36::after {
      content: '';
      cursor: col-resize;
      position: absolute;
      inset-block-start: 0;
      inset-inline-end: 0;
      inset-block-end: 0;
      inline-size: 10px;
    }
  }


@layer rdg.Row {.r1otpg647-0-0-beta-36 {
    display: contents;
    line-height: var(--rdg-row-height);
    background-color: var(--rdg-background-color)
}

    .r1otpg647-0-0-beta-36:hover {
      background-color: var(--rdg-row-hover-background-color);
    }

    .r1otpg647-0-0-beta-36[aria-selected='true'] {
      background-color: var(--rdg-row-selected-background-color);
    }

      .r1otpg647-0-0-beta-36[aria-selected='true']:hover {
        background-color: var(--rdg-row-selected-hover-background-color);
      }
  }

@layer rdg.FocusSink {

.rel5gk27-0-0-beta-36 {
    outline: 2px solid var(--rdg-selection-color);
    outline-offset: -2px
}
  }

@layer rdg.FocusSink {
    .r1qymf1z7-0-0-beta-36::before {
      content: '';
      display: inline-block;
      height: 100%;
      position: sticky;
      inset-inline-start: 0;
      border-inline-start: 2px solid var(--rdg-selection-color);
    }
  }


@layer rdg.HeaderRow {.h197vzie7-0-0-beta-36 {
    display: contents;
    line-height: var(--rdg-header-row-height);
    background-color: var(--rdg-header-background-color);
    font-weight: bold
}

    .h197vzie7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {
      /* Should have a higher value than 1 to show up above regular cells and the focus sink */
      z-index: 2;
      position: sticky;
      inset-block-start: 0;
    }

    .h197vzie7-0-0-beta-36 > .cd0kgiy7-0-0-beta-36 {
      z-index: 3;
    }
  }


@layer rdg.Cell {.ccpfvsn7-0-0-beta-36 {
    background-color: #ccccff
}
  }

@layer rdg.Cell {

.c1bmg16t7-0-0-beta-36 {
    background-color: #ccccff
}

    .c1bmg16t7-0-0-beta-36.ccpfvsn7-0-0-beta-36 {
      background-color: #9999ff;
    }
  }


@layer rdg.SortIcon {.a1mygwml7-0-0-beta-36 {
    fill: currentColor
}

    .a1mygwml7-0-0-beta-36 > path {
      transition: d 0.1s;
    }
  }


@layer rdg {
    @layer Defaults,
      FocusSink,
      CheckboxInput,
      CheckboxIcon,
      CheckboxLabel,
      Cell,
      HeaderCell,
      SummaryCell,
      EditCell,
      Row,
      HeaderRow,
      SummaryRow,
      GroupedRow,
      Root;

    @layer Defaults {
      .r104f42s7-0-0-beta-36 *,
      .r104f42s7-0-0-beta-36 *::before,
      .r104f42s7-0-0-beta-36 *::after {
        box-sizing: inherit;
      }
    }

    @layer Root {.r104f42s7-0-0-beta-36 {
      --rdg-color: #000;   --rdg-border-color: #ddd;   --rdg-summary-border-color: #aaa;   --rdg-background-color: hsl(0deg 0% 100%);   --rdg-header-background-color: hsl(0deg 0% 97.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 96%);   --rdg-row-selected-background-color: hsl(207deg 76% 92%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 88%);   --rdg-checkbox-color: hsl(207deg 100% 29%);   --rdg-checkbox-focus-color: hsl(207deg 100% 69%);   --rdg-checkbox-disabled-border-color: #ccc;   --rdg-checkbox-disabled-background-color: #ddd;
      --rdg-selection-color: #66afe9;
      --rdg-font-size: 14px;

      display: grid;

      color-scheme: var(--rdg-color-scheme, light dark);

      /* https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context */
      /* We set a stacking context so internal elements don't render on top of external elements. */
      /* size containment is not used as it could break "width: min-content" for example, and the grid would infinitely resize on Chromium browsers */
      contain: content;
      content-visibility: auto;
      block-size: 350px;
      border: 1px solid var(--rdg-border-color);
      box-sizing: border-box;
      overflow: auto;
      background-color: var(--rdg-background-color);
      color: var(--rdg-color);
      font-size: var(--rdg-font-size)

      /* needed on Firefox */
}
      .r104f42s7-0-0-beta-36::before {
        content: '';
        grid-column: 1/-1;
        grid-row: 1/-1;
      }

      .r104f42s7-0-0-beta-36.rdg-dark {
        --rdg-color-scheme: dark;
        --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;
      }

      .r104f42s7-0-0-beta-36.rdg-light {
        --rdg-color-scheme: light;
      }

      @media (prefers-color-scheme: dark) {
        .r104f42s7-0-0-beta-36:not(.rdg-light) {
          --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;
        }
      }
    }
  }

@layer rdg.Root {

.v7ly7s7-0-0-beta-36 {
    user-select: none
}

    .v7ly7s7-0-0-beta-36 .r1otpg647-0-0-beta-36 {
      cursor: move;
    }
  }

@layer rdg.FocusSink {

.fc4f4zb7-0-0-beta-36 {
    grid-column: 1/-1;
    pointer-events: none;
    /* Should have a higher value than 1 to show up above regular frozen cells */
    z-index: 1
}
  }

@layer rdg.FocusSink {

.fq51q037-0-0-beta-36 {
    /* Should have a higher value than 3 to show up above header and summary rows */
    z-index: 3
}
  }


@layer rdg.SummaryCell {.s1n3hxke7-0-0-beta-36 {
    inset-block-start: var(--rdg-summary-row-top);
    inset-block-end: var(--rdg-summary-row-bottom)
}
  }


@layer rdg.SummaryRow {.snfqesz7-0-0-beta-36 {
    line-height: var(--rdg-summary-row-height)
}

    .snfqesz7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {
      position: sticky;
    }
  }

@layer rdg.SummaryRow {
    .t1jijrjz7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {
      z-index: 2;
    }

    .t1jijrjz7-0-0-beta-36 > .cd0kgiy7-0-0-beta-36 {
      z-index: 3;
    }
  }

@layer rdg.SummaryRow {
    .t14bmecc7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {
      border-block-end: 2px solid var(--rdg-summary-border-color);
    }
  }

@layer rdg.SummaryRow {
    .b1odhhml7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {
      border-block-start: 2px solid var(--rdg-summary-border-color);
    }
  }


@layer rdg.GroupedRow {
    .gyxx7e97-0-0-beta-36:not([aria-selected='true']) {
      background-color: var(--rdg-header-background-color);
    }

    .gyxx7e97-0-0-beta-36 > .c1wupbe7-0-0-beta-36:not(:last-child):not(.c1730fa47-0-0-beta-36) {
      border-inline-end: none;
    }
  }


@layer rdg.TextEditor {.tlmcuo07-0-0-beta-36 {
    appearance: none;

    box-sizing: border-box;
    inline-size: 100%;
    block-size: 100%;
    padding-block: 0;
    padding-inline: 6px;
    border: 2px solid #ccc;
    vertical-align: top;
    color: var(--rdg-color);
    background-color: var(--rdg-background-color);

    font-family: inherit;
    font-size: var(--rdg-font-size)
}

    .tlmcuo07-0-0-beta-36:focus {
      border-color: var(--rdg-selection-color);
      outline: none;
    }

    .tlmcuo07-0-0-beta-36::placeholder {
      color: #999;
      opacity: 1;
    }
  }

`, "",{"version":3,"sources":["webpack://./node_modules/react-data-grid/lib/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;IACtB,eAAe;IACf,WAAW;IACX;AACJ;EACE;;;AAGF,iBAAiB;IACb;;;;MAIE;IACF,cAAc;IACd,kBAAkB,EAAE,4CAA4C;IAChE,gBAAgB;IAChB,mBAAmB;IACnB,oDAAoD;IACpD,mDAAmD;IACnD,yCAAyC;IACzC,yBAAyB;;IAEzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB;AACJ;;IAEI;MACE,6CAA6C;MAC7C,oBAAoB;IACtB;EACF;;AAEF;;AAEA;IACI,gBAAgB;IAChB,sEAAsE;IACtE;AACJ;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;;AAGF,0BAA0B;IACtB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,qBAAqB,EAAE,qCAAqC;AAChE;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC;AACJ;;IAEI;MACE,2CAA2C;MAC3C,8CAA8C;MAC9C,oBAAoB;IACtB;;IAEA;MACE,6CAA6C;IAC/C;EACF;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,uDAAuD;MACvD,+DAA+D;IACjE;EACF;;;AAGF,6BAA6B;IACzB;AACJ;EACE;;AAEF;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;IAEI;MACE,kBAAkB;IACpB;EACF;;;AAGF,uBAAuB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;IAEI;MACE,iBAAiB;MACjB,gBAAgB;MAChB,4CAA4C;MAC5C,6CAA6C;IAC/C;EACF;;;AAGF,qBAAqB;IACjB;AACJ;EACE;;;AAGF,+BAA+B;IAC3B,eAAe;IACf;AACJ;;IAEI;MACE,aAAa;IACf;EACF;;AAEF;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd;AACJ;EACE;;;AAGF,uBAAuB;IACnB;AACJ;;IAEI;MACE,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,oBAAoB;MACpB,mBAAmB;MACnB,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;;AAGF,gBAAgB;IACZ,iBAAiB;IACjB,kCAAkC;IAClC;AACJ;;IAEI;MACE,uDAAuD;IACzD;;IAEA;MACE,0DAA0D;IAC5D;;MAEE;QACE,gEAAgE;MAClE;EACJ;;AAEF;;AAEA;IACI,6CAA6C;IAC7C;AACJ;EACE;;AAEF;IACI;MACE,WAAW;MACX,qBAAqB;MACrB,YAAY;MACZ,gBAAgB;MAChB,qBAAqB;MACrB,yDAAyD;IAC3D;EACF;;;AAGF,sBAAsB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,oDAAoD;IACpD;AACJ;;IAEI;MACE,wFAAwF;MACxF,UAAU;MACV,gBAAgB;MAChB,oBAAoB;IACtB;;IAEA;MACE,UAAU;IACZ;EACF;;;AAGF,iBAAiB;IACb;AACJ;EACE;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,yBAAyB;IAC3B;EACF;;;AAGF,qBAAqB;IACjB;AACJ;;IAEI;MACE,kBAAkB;IACpB;EACF;;;AAGF;IACI;;;;;;;;;;;;;UAaM;;IAEN;MACE;;;QAGE,mBAAmB;MACrB;IACF;;IAEA,aAAa;MACX,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,yCAAyC,IAAI,iDAAiD,IAAI,kDAAkD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;MACziB,8BAA8B;MAC9B,qBAAqB;;MAErB,aAAa;;MAEb,iDAAiD;;MAEjD,gHAAgH;MAChH,6FAA6F;MAC7F,+IAA+I;MAC/I,gBAAgB;MAChB,wBAAwB;MACxB,iBAAiB;MACjB,yCAAyC;MACzC,sBAAsB;MACtB,cAAc;MACd,6CAA6C;MAC7C,uBAAuB;MACvB,8BAA8B;;MAE9B,sBAAsB;AAC5B;MACM;QACE,WAAW;QACX,iBAAiB;QACjB,cAAc;MAChB;;MAEA;QACE,wBAAwB;QACxB,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,wCAAwC,IAAI,iDAAiD,IAAI,iDAAiD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;MACziB;;MAEA;QACE,yBAAyB;MAC3B;;MAEA;QACE;UACE,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,wCAAwC,IAAI,iDAAiD,IAAI,iDAAiD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;QACziB;MACF;IACF;EACF;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,YAAY;IACd;EACF;;AAEF;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,4EAA4E;IAC5E;AACJ;EACE;;AAEF;;AAEA;IACI,+EAA+E;IAC/E;AACJ;EACE;;;AAGF,wBAAwB;IACpB,6CAA6C;IAC7C;AACJ;EACE;;;AAGF,uBAAuB;IACnB;AACJ;;IAEI;MACE,gBAAgB;IAClB;EACF;;AAEF;IACI;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;AAEF;IACI;MACE,2DAA2D;IAC7D;EACF;;AAEF;IACI;MACE,6DAA6D;IAC/D;EACF;;;AAGF;IACI;MACE,oDAAoD;IACtD;;IAEA;MACE,uBAAuB;IACzB;EACF;;;AAGF,uBAAuB;IACnB,gBAAgB;;IAEhB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;;IAE7C,oBAAoB;IACpB;AACJ;;IAEI;MACE,wCAAwC;MACxC,aAAa;IACf;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;EACF","sourcesContent":["@layer rdg.MeasuringCell {.m1l09lto7-0-0-beta-36 {\n    contain: strict;\n    grid-row: 1;\n    visibility: hidden\n}\n  }\n\n\n@layer rdg.Cell {.c1wupbe7-0-0-beta-36 {\n    /* max-content does not work with size containment\n     * dynamically switching between different containment styles incurs a heavy relayout penalty\n     * Chromium bug: at odd zoom levels or subpixel positioning, layout/paint containment can make cell borders disappear\n     *   https://bugs.chromium.org/p/chromium/issues/detail?id=1326946\n     */\n    contain: style;\n    position: relative; /* needed for absolute positioning to work */\n    padding-block: 0;\n    padding-inline: 8px;\n    border-inline-end: 1px solid var(--rdg-border-color);\n    border-block-end: 1px solid var(--rdg-border-color);\n    grid-row-start: var(--rdg-grid-row-start);\n    background-color: inherit;\n\n    white-space: nowrap;\n    overflow: hidden;\n    overflow: clip;\n    text-overflow: ellipsis;\n    outline: none\n}\n\n    .c1wupbe7-0-0-beta-36[aria-selected='true'] {\n      outline: 2px solid var(--rdg-selection-color);\n      outline-offset: -2px;\n    }\n  }\n\n@layer rdg.Cell {\n\n.cd0kgiy7-0-0-beta-36 {\n    position: sticky;\n    /* Should have a higher value than 0 to show up above unfrozen cells */\n    z-index: 1\n}\n  }\n\n@layer rdg.Cell {\n\n.c1730fa47-0-0-beta-36 {\n    box-shadow: calc(2px * var(--rdg-sign)) 0 5px -2px rgba(136, 136, 136, 0.3)\n}\n  }\n\n\n@layer rdg.CheckboxLabel {.c1hs68w07-0-0-beta-36 {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    margin-inline-end: 1px /* align checkbox in row group cell */\n}\n  }\n\n@layer rdg.CheckboxInput {\n\n.cojpd0n7-0-0-beta-36 {\n    all: unset\n}\n  }\n\n@layer rdg.CheckboxIcon {\n\n.cwsfieb7-0-0-beta-36 {\n    content: '';\n    inline-size: 20px;\n    block-size: 20px;\n    border: 2px solid var(--rdg-border-color);\n    background-color: var(--rdg-background-color)\n}\n\n    .cojpd0n7-0-0-beta-36:checked + .cwsfieb7-0-0-beta-36 {\n      background-color: var(--rdg-checkbox-color);\n      outline: 4px solid var(--rdg-background-color);\n      outline-offset: -6px;\n    }\n\n    .cojpd0n7-0-0-beta-36:focus + .cwsfieb7-0-0-beta-36 {\n      border-color: var(--rdg-checkbox-focus-color);\n    }\n  }\n\n@layer rdg.CheckboxLabel {\n\n.c1fgadbl7-0-0-beta-36 {\n    cursor: default\n}\n\n    .c1fgadbl7-0-0-beta-36 .cwsfieb7-0-0-beta-36 {\n      border-color: var(--rdg-checkbox-disabled-border-color);\n      background-color: var(--rdg-checkbox-disabled-background-color);\n    }\n  }\n\n\n@layer rdg.GroupCellContent {.g1w3c5217-0-0-beta-36 {\n    outline: none\n}\n  }\n\n@layer rdg.GroupCellCaret {\n\n.cm5tyhw7-0-0-beta-36 {\n    margin-inline-start: 4px;\n    stroke: currentColor;\n    stroke-width: 1.5px;\n    fill: transparent;\n    vertical-align: middle\n}\n\n    .cm5tyhw7-0-0-beta-36 > path {\n      transition: d 0.1s;\n    }\n  }\n\n\n@layer rdg.DragHandle {.cadd3bp7-0-0-beta-36 {\n    cursor: move;\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-end: 0;\n    inline-size: 8px;\n    block-size: 8px;\n    background-color: var(--rdg-selection-color)\n}\n\n    .cadd3bp7-0-0-beta-36:hover {\n      inline-size: 16px;\n      block-size: 16px;\n      border: 2px solid var(--rdg-selection-color);\n      background-color: var(--rdg-background-color);\n    }\n  }\n\n\n@layer rdg.EditCell {.c1tngyp17-0-0-beta-36 {\n    padding: 0\n}\n  }\n\n\n@layer rdg.SortableHeaderCell {.hizp7y17-0-0-beta-36 {\n    cursor: pointer;\n    display: flex\n}\n\n    .hizp7y17-0-0-beta-36:focus {\n      outline: none;\n    }\n  }\n\n@layer rdg.SortableHeaderCellName {\n\n.h14cojrm7-0-0-beta-36 {\n    flex-grow: 1;\n    overflow: hidden;\n    overflow: clip;\n    text-overflow: ellipsis\n}\n  }\n\n\n@layer rdg.HeaderCell {.celq7o97-0-0-beta-36 {\n    touch-action: none\n}\n\n    .celq7o97-0-0-beta-36::after {\n      content: '';\n      cursor: col-resize;\n      position: absolute;\n      inset-block-start: 0;\n      inset-inline-end: 0;\n      inset-block-end: 0;\n      inline-size: 10px;\n    }\n  }\n\n\n@layer rdg.Row {.r1otpg647-0-0-beta-36 {\n    display: contents;\n    line-height: var(--rdg-row-height);\n    background-color: var(--rdg-background-color)\n}\n\n    .r1otpg647-0-0-beta-36:hover {\n      background-color: var(--rdg-row-hover-background-color);\n    }\n\n    .r1otpg647-0-0-beta-36[aria-selected='true'] {\n      background-color: var(--rdg-row-selected-background-color);\n    }\n\n      .r1otpg647-0-0-beta-36[aria-selected='true']:hover {\n        background-color: var(--rdg-row-selected-hover-background-color);\n      }\n  }\n\n@layer rdg.FocusSink {\n\n.rel5gk27-0-0-beta-36 {\n    outline: 2px solid var(--rdg-selection-color);\n    outline-offset: -2px\n}\n  }\n\n@layer rdg.FocusSink {\n    .r1qymf1z7-0-0-beta-36::before {\n      content: '';\n      display: inline-block;\n      height: 100%;\n      position: sticky;\n      inset-inline-start: 0;\n      border-inline-start: 2px solid var(--rdg-selection-color);\n    }\n  }\n\n\n@layer rdg.HeaderRow {.h197vzie7-0-0-beta-36 {\n    display: contents;\n    line-height: var(--rdg-header-row-height);\n    background-color: var(--rdg-header-background-color);\n    font-weight: bold\n}\n\n    .h197vzie7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {\n      /* Should have a higher value than 1 to show up above regular cells and the focus sink */\n      z-index: 2;\n      position: sticky;\n      inset-block-start: 0;\n    }\n\n    .h197vzie7-0-0-beta-36 > .cd0kgiy7-0-0-beta-36 {\n      z-index: 3;\n    }\n  }\n\n\n@layer rdg.Cell {.ccpfvsn7-0-0-beta-36 {\n    background-color: #ccccff\n}\n  }\n\n@layer rdg.Cell {\n\n.c1bmg16t7-0-0-beta-36 {\n    background-color: #ccccff\n}\n\n    .c1bmg16t7-0-0-beta-36.ccpfvsn7-0-0-beta-36 {\n      background-color: #9999ff;\n    }\n  }\n\n\n@layer rdg.SortIcon {.a1mygwml7-0-0-beta-36 {\n    fill: currentColor\n}\n\n    .a1mygwml7-0-0-beta-36 > path {\n      transition: d 0.1s;\n    }\n  }\n\n\n@layer rdg {\n    @layer Defaults,\n      FocusSink,\n      CheckboxInput,\n      CheckboxIcon,\n      CheckboxLabel,\n      Cell,\n      HeaderCell,\n      SummaryCell,\n      EditCell,\n      Row,\n      HeaderRow,\n      SummaryRow,\n      GroupedRow,\n      Root;\n\n    @layer Defaults {\n      .r104f42s7-0-0-beta-36 *,\n      .r104f42s7-0-0-beta-36 *::before,\n      .r104f42s7-0-0-beta-36 *::after {\n        box-sizing: inherit;\n      }\n    }\n\n    @layer Root {.r104f42s7-0-0-beta-36 {\n      --rdg-color: #000;   --rdg-border-color: #ddd;   --rdg-summary-border-color: #aaa;   --rdg-background-color: hsl(0deg 0% 100%);   --rdg-header-background-color: hsl(0deg 0% 97.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 96%);   --rdg-row-selected-background-color: hsl(207deg 76% 92%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 88%);   --rdg-checkbox-color: hsl(207deg 100% 29%);   --rdg-checkbox-focus-color: hsl(207deg 100% 69%);   --rdg-checkbox-disabled-border-color: #ccc;   --rdg-checkbox-disabled-background-color: #ddd;\n      --rdg-selection-color: #66afe9;\n      --rdg-font-size: 14px;\n\n      display: grid;\n\n      color-scheme: var(--rdg-color-scheme, light dark);\n\n      /* https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context */\n      /* We set a stacking context so internal elements don't render on top of external elements. */\n      /* size containment is not used as it could break \"width: min-content\" for example, and the grid would infinitely resize on Chromium browsers */\n      contain: content;\n      content-visibility: auto;\n      block-size: 350px;\n      border: 1px solid var(--rdg-border-color);\n      box-sizing: border-box;\n      overflow: auto;\n      background-color: var(--rdg-background-color);\n      color: var(--rdg-color);\n      font-size: var(--rdg-font-size)\n\n      /* needed on Firefox */\n}\n      .r104f42s7-0-0-beta-36::before {\n        content: '';\n        grid-column: 1/-1;\n        grid-row: 1/-1;\n      }\n\n      .r104f42s7-0-0-beta-36.rdg-dark {\n        --rdg-color-scheme: dark;\n        --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;\n      }\n\n      .r104f42s7-0-0-beta-36.rdg-light {\n        --rdg-color-scheme: light;\n      }\n\n      @media (prefers-color-scheme: dark) {\n        .r104f42s7-0-0-beta-36:not(.rdg-light) {\n          --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;\n        }\n      }\n    }\n  }\n\n@layer rdg.Root {\n\n.v7ly7s7-0-0-beta-36 {\n    user-select: none\n}\n\n    .v7ly7s7-0-0-beta-36 .r1otpg647-0-0-beta-36 {\n      cursor: move;\n    }\n  }\n\n@layer rdg.FocusSink {\n\n.fc4f4zb7-0-0-beta-36 {\n    grid-column: 1/-1;\n    pointer-events: none;\n    /* Should have a higher value than 1 to show up above regular frozen cells */\n    z-index: 1\n}\n  }\n\n@layer rdg.FocusSink {\n\n.fq51q037-0-0-beta-36 {\n    /* Should have a higher value than 3 to show up above header and summary rows */\n    z-index: 3\n}\n  }\n\n\n@layer rdg.SummaryCell {.s1n3hxke7-0-0-beta-36 {\n    inset-block-start: var(--rdg-summary-row-top);\n    inset-block-end: var(--rdg-summary-row-bottom)\n}\n  }\n\n\n@layer rdg.SummaryRow {.snfqesz7-0-0-beta-36 {\n    line-height: var(--rdg-summary-row-height)\n}\n\n    .snfqesz7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {\n      position: sticky;\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .t1jijrjz7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {\n      z-index: 2;\n    }\n\n    .t1jijrjz7-0-0-beta-36 > .cd0kgiy7-0-0-beta-36 {\n      z-index: 3;\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .t14bmecc7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {\n      border-block-end: 2px solid var(--rdg-summary-border-color);\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .b1odhhml7-0-0-beta-36 > .c1wupbe7-0-0-beta-36 {\n      border-block-start: 2px solid var(--rdg-summary-border-color);\n    }\n  }\n\n\n@layer rdg.GroupedRow {\n    .gyxx7e97-0-0-beta-36:not([aria-selected='true']) {\n      background-color: var(--rdg-header-background-color);\n    }\n\n    .gyxx7e97-0-0-beta-36 > .c1wupbe7-0-0-beta-36:not(:last-child):not(.c1730fa47-0-0-beta-36) {\n      border-inline-end: none;\n    }\n  }\n\n\n@layer rdg.TextEditor {.tlmcuo07-0-0-beta-36 {\n    appearance: none;\n\n    box-sizing: border-box;\n    inline-size: 100%;\n    block-size: 100%;\n    padding-block: 0;\n    padding-inline: 6px;\n    border: 2px solid #ccc;\n    vertical-align: top;\n    color: var(--rdg-color);\n    background-color: var(--rdg-background-color);\n\n    font-family: inherit;\n    font-size: var(--rdg-font-size)\n}\n\n    .tlmcuo07-0-0-beta-36:focus {\n      border-color: var(--rdg-selection-color);\n      outline: none;\n    }\n\n    .tlmcuo07-0-0-beta-36::placeholder {\n      color: #999;\n      opacity: 1;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
